'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const membershipService = import('od-modules/secure_store/services/MembershipService');
const logger = require('od-modules/utils/logger');

module.exports = createWidgetFactory({
    name: 'cheap_repricing_manager',
    viewClass: require('./view'),
    modelClass: Backbone.Model.extend({
        connect: true,
        selectors: ['bookingId'],
        defaults: {
            bookingId: 0,
            membershipSubscriptionDetailsDTO: null,
        },
        initialize() {
            membershipService.then(({default: service}) => {
                service
                    .getMembershipSubscriptionDetails()
                    .then(this.updateMembershipSubscriptionDetailsDTO.bind(this))
                    .catch(() => this.set('membershipSubscriptionDetailsDTO', {}));
            });
        },
        updateMembershipSubscriptionDetailsDTO(data) {
            this.set('membershipSubscriptionDetailsDTO', data);
            this.trigger('membershipSubscriptionDetailsDTO:updated');
        },
    }),
    methods: {
        toggleCheapRepricing(totalPriceDifference, totalPrice) {
            logger.message(`Toggling cheap repricing for NON-meta with:
                total price difference ${totalPriceDifference} and total price ${totalPrice}`);
            this.renderMetasRepricing(totalPriceDifference, totalPrice);
        },
        toggleMetasCheapRepricing(totalPriceDifference, repricingMAPI) {
            logger.message(`Toggling cheap repricing for META with:
                total price difference ${totalPriceDifference} and repricingMAPI ${repricingMAPI}`);
            this.renderMetasRepricing(totalPriceDifference, repricingMAPI);
        },
    },
});
